import { ThunkAction } from "redux-thunk";
import { Dispatch, ActionCreator, Action } from "redux";

import { ApplicationState } from "../store/ApplicationState";
export const resetStates: ActionCreator<
    ThunkAction<void, ApplicationState, Record<string, never>, Action<string>>
> = (actionType: string[]) => {
    return async (dispatch: Dispatch) => {
        return actionType.map((singleAction) => {
            dispatch({
                type: singleAction,
            });
        });
    };
};